import api from "../config/apiConfig";
import {
  getSelectedActivity,
  getSelectedCompany,
  getSelectedDms,
  getSelectedPerson,
} from "../utils/auth";
import { getRegisterId } from "../utils/authId";

//Fetch Home Pannel
export const viewHomePannelDta = async () => {
  const id = getRegisterId();
  const selectedComp = getSelectedCompany() || {};
  try {
    const response = await api.get(
      `api/userlist_in_company_select/?company_id=${selectedComp.id}&register_id=${id}`,
      {}
    );
    return response;
  } catch (error) {
    throw error;
  }
};

//Fetch Conversation Homepannel
export const viewConversationHomepg = async (page) => {
  const id = getSelectedPerson() || {};
  const regId = getRegisterId();
  const limit = 50;
  // console.log(page, "page page");
  try {
    const response = await api.get(
      `api/get_single_chat_details_pagination/${
        id.chat_unique || 1
      }?register_id=${regId}&page=${page}&per_page=${limit}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

//Fetch Conversation Dms
export const viewConversationDms = async () => {
  const id = getSelectedDms() || {};
  const regId = getRegisterId();

  try {
    const response = await api.get(
      `api/get_single_chat_details/${
        id?.chat_unique || 1
      }?register_id=${regId}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

//Fetch Conversation Activity

export const viewConversationActivity = async () => {
  const id = getSelectedActivity() || {};
  const regId = getRegisterId();

  try {
    const response = await api.get(
      `api/get_single_chat_details/${
        id.chat_unique_id || 1
      }?register_id=${regId}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const viewSelConversationActivity = async () => {
  const id = getSelectedActivity() || {};
  const regId = getRegisterId();

  try {
    const response = await api.get(
      `api/get_single_activity_details/${
        id.chat_unique_id || 1
      }?register_id=${regId}&message_id=${id.message_id}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Fetch Dms
export const viewDms = async (search = "") => {
  const regId = getRegisterId();
  const selectedComp = getSelectedCompany() || {};

  try {
    const response =
      await api.get(`api/direct_message_list/?register_id=${regId}&company_id=${selectedComp.id}&search=${search}
`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

//fetch activity

export const viewActivity = async () => {
  const regId = getRegisterId();
  const selectedComp = getSelectedCompany() || {};

  try {
    const response = await api.get(
      `api/get_activity_details?register_id=${regId}&company_id=${selectedComp.id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
